export default __webpack_public_path__ + "static/media/vintage65g-6.b22da8df.jpg";